import SVGIcon, { type SVGIconProps } from "@ch/components/Icons/SVGIcon";
import type { FC } from "react";

type ThumbsUpIconProps = Partial<SVGIconProps>;

const ThumbsUpIcon: FC<ThumbsUpIconProps> = (props) => {
  return (
    <SVGIcon
      {...props}
      fill="none"
      height="20"
      viewBox="0 0 21 20"
      width="21"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.1662 4.86306C11.1662 4.33711 10.7598 3.9071 10.244 3.86763L7.87828 9.19034C7.84438 9.2666 7.80312 9.33807 7.7571 9.40541V16.1364H14.1838C14.8568 16.1364 15.4298 15.645 15.5321 14.9798L16.2658 10.2071C16.3928 9.38113 15.7539 8.63636 14.9182 8.63636H12.5298C11.7767 8.63636 11.1662 8.02584 11.1662 7.27273V4.86306ZM4.34801 15.4545C4.34801 15.8311 4.65327 16.1364 5.02983 16.1364H6.39347V10H5.02983C4.65327 10 4.34801 10.3053 4.34801 10.6818V15.4545ZM12.5298 7.27273H14.9182C16.5897 7.27273 17.8683 8.76275 17.6142 10.4148L16.8797 15.1875C16.675 16.5179 15.5298 17.5 14.1838 17.5H5.02983C3.90016 17.5 2.98438 16.5842 2.98438 15.4545V10.6818C2.98438 9.55215 3.90016 8.63636 5.02983 8.63636H6.6325L9.03152 3.23775L9.07147 3.15518C9.28644 2.75385 9.70658 2.5 10.1668 2.5L10.2886 2.50333C11.5371 2.56675 12.5298 3.59885 12.5298 4.86306V7.27273Z"
        fill="#0D121C"
      />
    </SVGIcon>
  );
};

export default ThumbsUpIcon;
